var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * For querying the status of the disbursement(s)
 * @param client
 * @param params
 * @returns state of each of the requested disbursements
 */
export function queryDisbursements(client, params) {
    return __awaiter(this, void 0, void 0, function* () {
        if (params.transfers.length === 0) {
            throw new Error("queryDisbursements: at least one transfer id is required");
        }
        const form = new URLSearchParams();
        if ("company" in params) {
            form.set("company", params.company);
        }
        else {
            form.set("wallet", params.wallet);
        }
        for (const t of params.transfers) {
            form.append("id", t);
        }
        // non-ok responses are thrown by `client.fetch`
        const res = yield client.fetch(client.joinPath("/v1/disburse/query"), {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: form.toString(),
        });
        return (yield res.json());
    });
}
